import gql from 'graphql-tag'

export default gql`
  mutation UserInviteToSlack($id: ID!) {
    userSlackInvite(id: $id) {
      id
    }
  }
`
